import { Link } from "react-router-dom";
import { works } from "@/mocks/comics";
import SectionHeading from "@/components/feature/SectionHeading";

export default function LatestUpdates() {
  const latest = [...works]
    .sort((a, b) => (a.lastUpdated < b.lastUpdated ? 1 : -1))
    .slice(0, 6);

  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="最新章节更新"
          title="最近更新，追更不掉队"
          desc="漫蛙漫画网聚合全站最新连载更新，一眼掌握每部作品的动态，点击即可直达最新章节。"
          action={
            <Link
              to="/works"
              className="whitespace-nowrap rounded-full px-5 py-2.5 text-sm font-semibold text-primary-700 ring-1 ring-primary-200 transition-colors hover:bg-primary-100"
            >
              查看全部 <i className="ri-arrow-right-line ml-1" aria-hidden="true" />
            </Link>
          }
        />

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {latest.map((w) => (
            <Link
              key={w.id}
              to={`/works/${w.id}`}
              className="group flex items-center gap-4 rounded-xl bg-background-100 p-3 ring-1 ring-background-200 transition-colors hover:ring-primary-300"
            >
              <div className="relative h-24 w-16 shrink-0 overflow-hidden rounded-lg">
                <img
                  src={w.cover}
                  alt={`${w.title} 封面`}
                  title={`${w.title} 最新章节`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="truncate font-heading text-base font-bold text-foreground-950 group-hover:text-primary-700">
                    {w.title}
                  </h3>
                  <span className="shrink-0 rounded-full bg-background-200 px-2 py-0.5 text-xs text-foreground-600">
                    {w.category}
                  </span>
                </div>
                <p className="mt-1.5 truncate text-sm font-medium text-primary-700">{w.lastChapter}</p>
                <div className="mt-2 flex items-center justify-between text-xs text-foreground-500">
                  <span>{w.author}</span>
                  <span>{w.lastUpdated}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}